


















import Vue from "vue";

interface ComponentState {
  open: boolean,
}

export default Vue.extend({
  name: "VSelect",
  props: {
    placeholder: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    selectOptions: {
      type: Array.of(Object),
      required: true
    }
  },
  data(): ComponentState {
    return {
      open: false
    };
  },
  methods: {
    handleClick(nextValue: string): void {
      this.open = false;
      this.$emit("input", nextValue);
    }
  },
  computed: {
    selectedText(): string | null {
      if (this.value) {
        const found = this.selectOptions.find((item: { value: string, text: string }) => item.value === this.value);
        return found.text;
      }
      return null;
    }
  }
});
